import * as React from 'react';
import classNames from 'classnames';
import styles from './Base.module.css';
import Label from './Label';
import { TooltipSimple } from './TooltipSimple/TooltipSimple';
export function InputBase(props) {
    var _a, _b, _c;
    var forwardedRef = props.forwardedRef, label = props.label, _d = props.isValid, isValid = _d === void 0 ? true : _d, _e = props.required, required = _e === void 0 ? false : _e, inputComponent = props.inputComponent, value = props.value, onChange = props.onChange, onBlur = props.onBlur, name = props.name, hint = props.hint, style = props.style, labelStyle = props.labelStyle, inputStyle = props.inputStyle, validationMessage = props.validationMessage, labelType = props.labelType, disabled = props.disabled, recommendationMessage = props.recommendationMessage, className = props.className;
    var inputProps = {
        name: name,
        value: value,
        onChange: onChange,
        onBlur: onBlur,
        className: classNames(styles.controlInput, (_a = {},
            _a[styles.controlInputInvalid] = !isValid,
            _a)),
        id: name,
        'data-testid': name,
        disabled: disabled
    };
    return (React.createElement("div", { className: classNames(styles.control, className, (_b = {},
            _b[styles.controlTop] = labelType === 'top',
            _b)), ref: forwardedRef, style: style },
        label && (React.createElement(Label, { label: label, labelType: labelType, labelStyle: labelStyle, required: required, for: name })),
        hint && (React.createElement(TooltipSimple, { text: hint, style: { marginTop: '13px', right: '-25px', position: 'absolute' }, inputBaseStyle: true })),
        React.createElement("div", { className: classNames(styles.inputContainer, (_c = {},
                _c[styles.inputContainerTop] = labelType === 'top',
                _c)), style: inputStyle },
            inputComponent(inputProps),
            recommendationMessage && (React.createElement("div", { className: styles.recommendationMessage }, recommendationMessage)),
            isValid === false && validationMessage && (React.createElement("div", { className: styles.validationMessage }, validationMessage)))));
}
